export function validateCandlePattern(data) {
  const { pattern, tradePlan } = data;

  if (
    tradePlan.entryTactics?.CANDLE_BREAK &&
    !tradePlan.entryTactics?.CANDLE_BREAK?.waitUntilCurrentCandleCloses
  )
    return [
      false,
      'You cannot select \'Wait for Candle Close\' in Candle Break entry when using Candle Pattern setup',
    ];
  if (pattern.length === 0)
    return [false, 'You must add at least one candle pattern.'];
  let result = [true, ''];
  for (const singlePattern of pattern) {
    const patternLength = singlePattern.length;
    const lastSequence = patternLength - 1;
    if (!patternLength) continue;
    singlePattern.forEach(({ candleSequence }, index) => {
      if (index !== lastSequence) {
        if (candleSequence === 'BREAK_CANDLE') {
          result = [false, '2 can only be used as the last sequence.'];
        }
        if (candleSequence === 'OUTSIDE_CANDLE_UP')
          result = [false, '3u can only be used as the last sequence.'];
        if (candleSequence === 'OUTSIDE_CANDLE_DOWN')
          result = [false, '3d can only be used as the last sequence.'];
      } else {
        if (
          candleSequence === 'INSIDE_CANDLE' ||
          candleSequence === 'FAIL_TO_BREAK_LOW' ||
          candleSequence === 'FAIL_TO_BREAK_HIGH'
        )
          result = [false, 'Last sequence must be a break low or break high.'];
        if (!tradePlan.goLong && tradePlan.goShort) {
          if (
            candleSequence === 'BREAK_HIGH' ||
            candleSequence === 'OUTSIDE_CANDLE_UP'
          )
            result = [false, 'Cannot enter long on a break low sequence.'];
        } else if (!tradePlan.goShort && tradePlan.goLong) {
          if (
            candleSequence === 'BREAK_LOW' ||
            candleSequence === 'OUTSIDE_CANDLE_DOWN'
          )
            result = [false, 'Cannot enter short on a break high sequence.'];
        }
      }
    });
  }
  return result;
}
